import { PropsWithChildren, useContext } from "react";
import { Body1Stronger, Button, Card, CardFooter, CardHeader, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    KeyMultipleRegular,
    EditRegular,
    DeleteRegular,
    PeopleEditRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IApplicationRoleTileProps } from "./application-roles-tile.props";
import { PPAPermissions } from "lib/permissions";
import Trimmed from "components/common/trimmed/trimmed";

const layoutStyles = makeStyles({
    mainWrapper: {
        //...shorthands.borderWidth('1px', '0'),
    },
    description: {
        fontSize: tokens.fontSizeBase200,
        lineHeight: 'normal'
    }
});

export default function ApplicationRoleTile(props: IApplicationRoleTileProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const onEditHandler = () => {
        if (props.onEditApplicationRoleClick && props.applicationRole?.id)
            props.onEditApplicationRoleClick(props.applicationRole.id)
    }

    const onEditPermissionLevelHandler = () => {
        if (props.onEditApplicationRolePermissionLevelClick && props.applicationRole?.id)
            props.onEditApplicationRolePermissionLevelClick(props.applicationRole.id)
    }

    const onDeleteHandler = () => {
        if (props.onDeleteApplicationRoleClick && props.applicationRole?.id)
            props.onDeleteApplicationRoleClick(props.applicationRole.id)
    }

    const onEditMembershipHandler = () => {
        if (props.onEditApplicationRoleMembershipClick && props.applicationRole?.id)
            props.onEditApplicationRoleMembershipClick(props.applicationRole.id)
    }

    return (
        <Card>
            <CardHeader
                header={<Body1Stronger>{props.applicationRole.name}</Body1Stronger>}
                description={props.applicationRole.description &&
                    <span
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: props.applicationRole.description }}></span>} />
            <CardFooter>
                <Trimmed permission={PPAPermissions.UpdateApplicationRole}>
                    <Button
                        icon={<EditRegular />}
                        onClick={onEditHandler}></Button>
                </Trimmed>
                <Button
                    icon={<KeyMultipleRegular />}
                    onClick={onEditPermissionLevelHandler}></Button>
                <Button
                    icon={<PeopleEditRegular />}
                    onClick={onEditMembershipHandler}></Button>
                <Trimmed permission={PPAPermissions.DeleteApplicationRole}>
                    <Button
                        icon={<DeleteRegular />}
                        onClick={onDeleteHandler}></Button>
                </Trimmed>
            </CardFooter>
        </Card>
    );
}